import { ACTION_REGO_SEARCH, ACTION_REGO_REMOVE, ACTION_REGO_SEARCHED, ACTION_RESET_REGO_SEARCHED, ACTION_REGO_LOOKUP_COMPLETED, ACTION_RESET_REGO_LOOKUP_COMPLETED } from './actions'
import { REGO_SEARCH, REGO_REMOVE, REGO_SEARCHED, RESET_REGO_SEARCHED, REGO_LOOKUP_COMPLETED, RESET_REGO_LOOKUP_COMPLETED } from './mutations'
import { SET_INFO_SUCCESS } from '../info/mutations'
const state = {
    rego: {},
    searched: false,
    agRegoLookupCompleted: false,
}

const getters = {
    regoSearch(state) {
        return state.rego
    },
    searched(state) {
        return state.searched
    },
    agRegoLookupCompleted(state) {
        return state.agRegoLookupCompleted
    }
}

const actions = {
    async [ACTION_REGO_SEARCH](context, payload) {
        context.commit(REGO_SEARCH, payload)
        context.commit(SET_INFO_SUCCESS, {
            ...payload
        })
    },

    async [ACTION_REGO_REMOVE](context) {
        context.commit(REGO_REMOVE)
    },

    async [ACTION_REGO_SEARCHED](context) {
        context.commit(REGO_SEARCHED)
    },

    async [ACTION_RESET_REGO_SEARCHED](context) {
        context.commit(RESET_REGO_SEARCHED)
    },

    async [ACTION_REGO_LOOKUP_COMPLETED](context) {
        context.commit(REGO_LOOKUP_COMPLETED)
    },

    async [ACTION_RESET_REGO_LOOKUP_COMPLETED](context) {
        context.commit(RESET_REGO_LOOKUP_COMPLETED)
    }
}

const mutations = {
    [REGO_SEARCH](state, payload) {
        state.rego = payload
    },

    [REGO_REMOVE](state) {
        state.rego = {}
    },

    [REGO_SEARCHED](state) {
        state.searched = true
    },

    [RESET_REGO_SEARCHED](state) {
        state.searched = false
    },

    [REGO_LOOKUP_COMPLETED](state) {
        state.agRegoLookupCompleted = true
    },

    [RESET_REGO_LOOKUP_COMPLETED](state) {
        state.agRegoLookupCompleted = false
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
